export const FIELD_IS_REQUIRED_ERROR = "common.message.requiredField";
export const EMAIL_FORMAT_INCORRECT_ERROR = "common.message.emailFormat";
export const EMAIL_DUPLICATE_ERROR = "common.message.emailDuplicate";
export const ONBOARDING_EMAIL_REGISTERED = "public.register.status";
